import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Welcome.css";
import { useAuth } from "../context/AuthContext";

// Where each button goes. Logged-out visitors are sent to login and brought back to the same place afterwards.
const buildActions = (loggedIn) => {
  const gated = (path) => (loggedIn ? path : `/login?next=${encodeURIComponent(path)}`);
  return [
    { emoji: "📤", label: "Post a Listing",  sub: "Free & easy",     path: gated("/dashboard/post"),     accent: "#f97316" },
    { emoji: "🔍", label: "Browse Listings", sub: "1000s of items",  path: "/all",                       accent: "#3b82f6" },
    { emoji: "👤", label: "My Account",      sub: loggedIn ? "Open dashboard" : "Log in or sign up", path: gated("/dashboard"), accent: "#10b981" },
    { emoji: "💼", label: "For Business",    sub: "Grow your sales", path: gated("/dashboard/business"), accent: "#8b5cf6" },
  ];
};

const Welcome = () => {
  const { isLoggedIn, loading } = useAuth();
  const signedIn = isLoggedIn || loading;          // loading = saved token, profile still being fetched
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div className="welcome-wrap">
      <div className="welcome-inner">
        <div className="welcome-text">
          <h3>Welcome to <strong>TroveHub</strong></h3>
          <h2 className="welcome-headline">Buy &amp; Sell Safely Across Nigeria</h2>
          <p>Direct deals and secure payments with TrovePay Escrow.</p>
        </div>
        <form className="welcome-search" onSubmit={submit}>
          <input
            type="text"
            placeholder="Search cars, phones, houses..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Search listings"
          />
          <button type="submit">Search</button>
        </form>
        <div className="welcome-actions">
          {buildActions(signedIn).map((a) => (
            <Link key={a.label} to={a.path} className="action-card" style={{ "--ac": a.accent }}>
              <div className="ac-emoji" aria-hidden="true">{a.emoji}</div>
              <div className="ac-text">
                <span className="ac-label">{a.label}</span>
                <span className="ac-sub">{a.sub}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
